<app-question-base
  [question]="question"
  [isFirstQuestion]="isFirstQuestion"
></app-question-base>
